// src/components/common/FeatureSection.tsx

import React from "react";
import { FeatureSectionData } from "../../types/interfaces";
import { Link } from "react-router-dom";
import "../../styles/FeatureSection.css";

interface FeatureSectionProps extends FeatureSectionData {
  requestServiceName?: string;
}

const getRequestAwareLink = (href: string, requestServiceName?: string) => {
  if (href !== "/contact" || !requestServiceName) {
    return href;
  }

  return `/contact?service=${encodeURIComponent(
    requestServiceName
  )}&source=solution-feature`;
};

const FeatureSection: React.FC<FeatureSectionProps> = ({
  title,
  description,
  image,
  ctaText,
  imagePosition = "left",
  id,
  ctaLink,
  pageType,
  requestServiceName,
}) => {
  const linkUrl = getRequestAwareLink(
    ctaLink ? ctaLink : `/${pageType}/${id}`,
    requestServiceName
  );
  const isExternalLink = /^https?:\/\//i.test(linkUrl);
  const isAnchorLink = linkUrl.startsWith("#");

  return (
    <section className={`feature-section ${imagePosition}`} id={id}>
      <div className="content-in-feature-section">
        <div className="image-wrapper">
          <img src={image} alt={title} />
        </div>
        <div className="content">
          <h2>{title}</h2>
          <p>{description}</p>
          {ctaText &&
            (isExternalLink || isAnchorLink ? (
              <a
                href={linkUrl}
                className="cta-button"
                target={isExternalLink ? "_blank" : undefined}
                rel={isExternalLink ? "noopener noreferrer" : undefined}
              >
                {ctaText}
              </a>
            ) : (
              <Link to={linkUrl} className="cta-button">
                {ctaText}
              </Link>
            ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
